import { Avatar, AvatarProps } from '@mui/material';
import { FC } from 'react';

const AvatarWrapper: FC<AvatarProps> = (props) => <Avatar {...props} />;

export default AvatarWrapper;
